import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { GlobalProvider } from './reducers/global';
import './scss/lxl-style.scss';

// eslint-disable-next-line
const rootEl = document.getElementById('mth-calc-app');

ReactDOM.render(
  <React.StrictMode>
    <GlobalProvider>
      <App />
    </GlobalProvider>
  </React.StrictMode>,
  rootEl
);
